import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../lib/i18next";
import {
  GALLERY_SELECTED_COUNT_PLURAL,
  GALLERY_SELECTED_COUNT_SINGULAR,
} from "../../i18n/keysTranslations";
import { GRAY_200, GRAY_300, GRAY_700, GRAY_800 } from "../../utils/colors";

const GallerySelectedCountChip = ({ selectedCount = 0, sx = {} }) => {
  const { t } = useTranslationApp();

  if (selectedCount < 1) {
    return null;
  }

  const label =
    selectedCount === 1
      ? t(GALLERY_SELECTED_COUNT_SINGULAR)
      : t(GALLERY_SELECTED_COUNT_PLURAL);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        borderRadius: 999,
        border: `1px solid ${GRAY_300}`,
        bgcolor: GRAY_200,
        py: 0.5,
        pl: 0.75,
        pr: 1.5,
        mt: 0.5,
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 24,
          minWidth: 24,
          px: 0.75,
          borderRadius: 999,
          bgcolor: GRAY_700,
          color: "common.white",
          fontSize: "0.75rem",
          fontWeight: 700,
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {selectedCount}
      </Box>
      <Typography
        component="span"
        variant="body2"
        sx={{
          fontWeight: 500,
          color: GRAY_800,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default GallerySelectedCountChip;
